import { rootContainer } from 'app/shadowRoot';
import { useEffect, useMemo } from 'react';

export default function useOpenAnimation({ halfOpen, isOpen }: { halfOpen: boolean; isOpen: boolean }) {
  useScreenHeight();

  const animationValues = useMemo(
    () => ({
      y: isOpen ? 0 : window.screen.height,
      height: halfOpen ? 'calc(var(--app-height) * 0.45)' : isOpen ? 'var(--screen-height)' : '0px',
      transition: halfOpen
        ? { type: 'spring', stiffness: 40, damping: 8, duration: 1.6, bounce: 1 }
        : isOpen
          ? { type: 'spring', stiffness: 60, damping: 10 }
          : { type: 'easeOut', duration: 1 },
    }),
    [isOpen, halfOpen]
  );

  return {
    controls: animationValues,
  };
}

function useScreenHeight() {
  useEffect(() => {
    function appHeight() {
      const oldHeight = rootContainer.style.getPropertyValue('--screen-height');
      const newHeight = window.innerWidth < 768 ? 'var(--app-height)' : 'auto';

      if (oldHeight !== newHeight) {
        rootContainer.style.setProperty('--screen-height', newHeight);
      }
    }
    window.addEventListener('resize', appHeight);
    appHeight();

    return () => {
      window.removeEventListener('resize', appHeight);
    };
  }, []);
}
